module.exports = __webpack_public_path__ + "assets/img/wdbm.c466afef.png";